import api from './api';

// Anonim SSO uçları: hata toast'ı, 401 yönlendirmesi ve 403 kendini onarma KAPALI — sayfa durumu kendisi gösterir
// (sandboxService.js SELF_HANDLED ile aynı gerekçe).
const SELF_HANDLED = { skipErrorToast: true, skipAuthRedirect: true, _skipSelfHeal: true };

export const discoverSso = (email) => api.post('/v1/auth/sso/discover', { email }, SELF_HANDLED);
export const exchangeSsoTicket = (ticket, verifier) => api.post('/v1/auth/sso/exchange', { ticket, verifier }, SELF_HANDLED);

// Yönetim (enterpriseAdmin)
export const getSsoConnections = () => api.get('/v1/sso/connections');
export const getSsoConnection = (id) => api.get(`/v1/sso/connections/${id}`);
export const createSsoConnection = (data) => api.post('/v1/sso/connections', data);
export const updateSsoConnection = (id, data) => api.put(`/v1/sso/connections/${id}`, data);
export const deleteSsoConnection = (id) => api.delete(`/v1/sso/connections/${id}`);
export const startSsoTest = (id) => api.post(`/v1/sso/connections/${id}/test`);
export const getSsoTestResult = (id, testId) =>
  api.get(`/v1/sso/connections/${id}/test-results/${encodeURIComponent(testId)}`, { passErrorBody: true });
export const getSsoEvents = (id, params) => api.get(`/v1/sso/connections/${id}/events?${new URLSearchParams(params || {})}`);

// Alan adı onayları (superAdmin)
export const getSsoDomainApprovals = (status) =>
  api.get(`/v1/sso/domain-approvals${status ? `?status=${status}` : ''}`);
export const approveSsoDomain = (id) => api.post(`/v1/sso/domain-approvals/${id}/approve`);
export const rejectSsoDomain = (id, note) => api.post(`/v1/sso/domain-approvals/${id}/reject`, { note });
export const revokeSsoDomain = (id, note) => api.post(`/v1/sso/domain-approvals/${id}/revoke`, { note });

export const SSO_MODES = { NONE: 'none', OPTIONAL: 'optional', REQUIRED: 'required' };
